// @flow

import React from 'react';
import isArray from 'lodash/isArray';
import size from 'lodash/size';
import isEmpty from 'lodash/isEmpty';

import completeUrlProtocal from './completeUrlProtocal';
import MediaIcon from './MediaIcon';
import './MediaLinkCell.scss';

type Props = {
  type: string,
  url: ?string | Array<string>,
  note: string,
  toggleGallery?: (val: boolean) => void
}

const renderPopoverNote = (note: string) => {
  return (
    <div className="popover popover--n results-ui-popover">{note}</div>
  );
};

const renderGalleryToggler = ({
  type, fillColor, note, toggleGallery,
}) => {
  return (
    <div
      className="media-link-cell gallery-toggler"
      data-popover-trigger
      onClick={ () => toggleGallery(true) }>
      <MediaIcon size="24px" type={type} color={fillColor} />
      {renderPopoverNote(note)}
    </div>
  );
};

const renderLink = ({
  url, type, fillColor, note,
}) => {
  const completedImportedUrl = isArray(url) ? completeUrlProtocal(url[0]) : completeUrlProtocal(url);
  return (
    <a href={completedImportedUrl} rel="noopener noreferrer" target="_blank" className="media-link-cell" data-popover-trigger>
      <MediaIcon size="24px" type={type} color={fillColor} />
      {renderPopoverNote(note)}
    </a>
  );
};

const renderDisabledButton = ({ type, fillColor, note }) => {
  return (
    <div className="media-link-cell disabled-link" data-popover-trigger>
      <MediaIcon size="24px" type={type} color={fillColor} />
      {renderPopoverNote(note)}
    </div>
  );
};

const FILL_COLOR = '#0070d9';
const DISABLED_COLOR = '#b8b8b8';

const MediaLinkCell = ({
  type, url, note, toggleGallery,
}: Props) => {
  if (isArray(url) && size(url) > 1) {
    return renderGalleryToggler({
      type, fillColor: FILL_COLOR, note, toggleGallery,
    });
  } if (isEmpty(url)) {
    return renderDisabledButton({ type, fillColor: DISABLED_COLOR, note });
  }
  return renderLink({
    url, type, fillColor: FILL_COLOR, note,
  });
};

export default MediaLinkCell;
